import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { AI_ASSISTANT_BLUE } from "../constants";

export default function QuizConfirmationCard({
  preview,
  onConfirm,
  onEdit,
  confirming,
  disabled,
}) {
  if (!preview) return null;
  const rules = preview.topic_rules || [];

  return (
    <Box
      sx={{
        mx: 2,
        mb: 1.5,
        p: 1.6,
        borderRadius: 2.5,
        border: `1px solid rgba(0, 97, 254, 0.25)`,
        bgcolor: "#f8fbff",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
      }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: 800, color: AI_ASSISTANT_BLUE, letterSpacing: 0.6 }}>
        CONFIRM QUIZ
      </Typography>
      <Typography fontWeight={700} sx={{ mt: 0.4, color: "#0f172a" }}>
        {preview.title}
      </Typography>
      <Typography variant="body2" sx={{ color: "#64748b", mt: 0.3 }}>
        {preview.time_limit_minutes} min · {preview.total_questions} questions
      </Typography>

      <Divider sx={{ my: 1.2 }} />

      <Stack spacing={0.8}>
        {rules.map((r, idx) => (
          <Box key={idx} sx={{ fontSize: 13, color: "#334155" }}>
            <strong>{r.source === "microlab" ? "Microlab" : "Private"}</strong>
            {r.catalogue ? ` · ${r.catalogue}` : ""}
            {r.topic_label ? ` · ${r.topic_label}` : ""}
            {Array.isArray(r.subtitles) && r.subtitles.length
              ? ` · ${r.subtitles.join(", ")}`
              : ""}
            {" · "}
            {r.difficulty || "any"} · {r.num_questions} Qs
          </Box>
        ))}
      </Stack>

      {preview.instructions_preview ? (
        <Typography variant="caption" sx={{ display: "block", mt: 1.2, color: "#64748b" }}>
          Instructions: {preview.instructions_preview}
          {preview.instructions_preview.length >= 240 ? "…" : ""}
        </Typography>
      ) : null}

      <Stack direction="row" spacing={1} sx={{ mt: 1.6 }}>
        <Button
          variant="contained"
          disableElevation
          disabled={disabled || confirming}
          onClick={onConfirm}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            color: "#ffffff !important",
            bgcolor: `${AI_ASSISTANT_BLUE} !important`,
            "&:hover": {
              color: "#ffffff !important",
              bgcolor: "#0052d6 !important",
            },
            "&.Mui-disabled": {
              color: "rgba(255,255,255,0.85) !important",
              bgcolor: "rgba(0, 97, 254, 0.45) !important",
            },
          }}
        >
          {confirming ? "Creating…" : "Create Quiz"}
        </Button>
        <Button
          variant="outlined"
          disabled={confirming}
          onClick={onEdit}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            color: `${AI_ASSISTANT_BLUE} !important`,
            borderColor: `${AI_ASSISTANT_BLUE} !important`,
            bgcolor: "#ffffff !important",
            "&:hover": {
              color: "#0052d6 !important",
              borderColor: "#0052d6 !important",
              bgcolor: "rgba(0, 97, 254, 0.06) !important",
            },
            "&.Mui-disabled": {
              color: "rgba(0, 97, 254, 0.4) !important",
              borderColor: "rgba(0, 97, 254, 0.25) !important",
            },
          }}
        >
          Configure the quiz
        </Button>
      </Stack>
    </Box>
  );
}

QuizConfirmationCard.propTypes = {
  preview: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  confirming: PropTypes.bool,
  disabled: PropTypes.bool,
};
